export default __webpack_public_path__ + "static/media/eco-iron.37898a53.png";